import React from 'react';

import useMultiHostingOnboarding from '~/hooks/useMultiHostingOnboarding';

import FirstSiteInstalling from '../../../../scenes/Hosting/scenes/HostingDetail/components/FirstSiteInstalling';

interface OnBoardingProps {
  latestPlanHostingId?: string;
  totalProductCount?: number;
}

const MultiHostingOnBoarding: React.FC<OnBoardingProps> = ({
  latestPlanHostingId = '',
  totalProductCount = 0,
}) => {
  const { onboarding, firstSiteId } =
    useMultiHostingOnboarding(latestPlanHostingId);

  const showOnboardingModal = onboarding?.completed === false && firstSiteId;

  return (
    <>
      {showOnboardingModal && (
        <FirstSiteInstalling
          siteId={firstSiteId}
          latestPlanId={latestPlanHostingId}
          totalProductCount={totalProductCount}
        />
      )}
    </>
  );
};

export default MultiHostingOnBoarding;
